import {
  DataMessageTypeEnum,
  TerraUIMessageDataPartName,
  type TerraUIMessage,
} from '@terra/shared-dto-chat-types';
import { readObjectValue } from '../../utils/readObjectValue';

export type UpdateSignalToolCompletion = {
  toolCallId: string;
  signalId?: string;
};

export function collectUpdateSignalToolCompletions({
  messages,
}: {
  messages: TerraUIMessage[];
}): UpdateSignalToolCompletion[] {
  const completions: UpdateSignalToolCompletion[] = [];

  for (const message of messages) {
    for (const part of message.parts) {
      if (part.type !== TerraUIMessageDataPartName) {
        continue;
      }

      const data = part.data;

      if (!data || data.type !== DataMessageTypeEnum.ToolCallComplete) {
        continue;
      }

      const toolName = String(readObjectValue(data, 'toolName') ?? '')
        .replace(/_/g, '-')
        .toLowerCase();

      if (toolName !== 'update-signal-tool') {
        continue;
      }

      const toolCallId = readObjectValue(data, 'toolCallId');

      if (typeof toolCallId !== 'string' || toolCallId.length === 0) {
        continue;
      }

      const input =
        data.input && typeof data.input === 'object' ? data.input : null;
      const output =
        data.output && typeof data.output === 'object' ? data.output : null;
      const signalIdCandidate =
        (input ? readObjectValue(input, 'signalId') : undefined) ??
        (output ? readObjectValue(output, 'signalId') : undefined);

      completions.push({
        toolCallId,
        signalId:
          typeof signalIdCandidate === 'string' && signalIdCandidate
            ? signalIdCandidate
            : undefined,
      });
    }
  }

  return completions;
}
